import { render, staticRenderFns } from "./BotButtonMessage.vue?vue&type=template&id=1ea7821c&scoped=true"
import script from "./BotButtonMessage.vue?vue&type=script&lang=js"
export * from "./BotButtonMessage.vue?vue&type=script&lang=js"
import style0 from "./BotButtonMessage.vue?vue&type=style&index=0&id=1ea7821c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea7821c",
  null
  
)

export default component.exports